module.exports = {
  title: `주 1회 작성하는 개발 블로그`,
  description: `배움을 기록하자`,
  author: `JinhyeongKim`,
  introduction: `주 1회 작성하는 개발 블로그`,
  siteUrl: `https://bnt10.github.io/`, // Your blog site url
  social: {
    twitter: ``, // Your Twitter account
    github: `bnt10/bnt10.github.io`, // Your github account, // Your GitHub account
    medium: ``, // Your Medium account
    facebook: ``, // Your Facebook account
    linkedin: ``, // Your LinkedIn account
    instagram: ``, // Your Instagram account
  },
  icon: `content/assets/felog.png`, // Add your favicon
  keywords: [`blog`],
  comment: {
    disqusShortName: 'bnt10-github-io', // Your disqus-short-name. check disqus.com.
    utterances: 'JinHyongKim/blog', // Your repository for archive comment
  },
  configs: {
    countOfInitialPost: 10, // Config your initial count of post
  },
  sponsor: {
    buyMeACoffeeId: '',
  },
  share: {
    facebookAppId: '', // Add facebookAppId for using facebook share feature v3.2
  },
  ga: '0', // Add your google analytics tranking ID
  ad: '', // Add your google adsense publisherId `ca-pub-xxxxxxxxxx`

}
